import { useEffect } from 'react'
import { useSearch } from 'wouter'
import queryString from 'query-string'

import { useDocumentState } from '@/state'
import { Spinner } from '@/components/ui/spinner'
import { useDocumentPageContextQuery } from '@/pages/DocumentPage/queries'
import { useKickViewWorker } from '@/services/hooks/view_worker'
import { useCheckDocumentImagesRendered } from '@/utils/hooks/useCheckDocumentImagesRendered'

import { WorkInstructions } from './WorkInstructions'
import { ProjectTracker } from './ProjectTracker'

export const Documents = () => {
  useKickViewWorker({ kickOnMount: true })

  const { isLoading, data } = useDocumentPageContextQuery()
  const scrollToPage = useDocumentState((state) => state.scrollToPageId)
  const defaultZoom = useDocumentState((state) => state.defaultZoom)
  const search = useSearch()
  const searchParams = queryString.parse(search) as {
    cv?: string // cad version
    dv?: string // document version
    page_id?: string // document page id
  }
  const pageId = searchParams.page_id
  const { isRendered } = useCheckDocumentImagesRendered()

  useEffect(() => {
    if (window.Cypress) {
      // @ts-expect-error - extending window for Cypress testing
      window.$$appStore = useDocumentState

      if (isRendered) {
        // @ts-expect-error - extending window for Cypress testing
        window.$$imagesRendered = isRendered
      }
    }
  }, [isRendered])

  useEffect(() => {
    if (!isLoading && pageId && defaultZoom) {
      scrollToPage(pageId)
    }
  }, [isLoading, pageId, defaultZoom])

  if (isLoading) {
    return <Spinner />
  }

  return data?.documentType === 'project_tracker' ? (
    <ProjectTracker />
  ) : (
    <WorkInstructions />
  )
}
